var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarUserActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.515,
    height: 19.499,
    viewBox: "0 0 19.515 19.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-5752333",
    transform: "translate(-84.471 -14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37616",
    "data-name": "Path 37616",
    d: "M99.7,32.018c.012-.1.023-.194.03-.29q.016-.207.016-.426a5.514,5.514,0,1,0-11.028,0q0,.219.016.426c.007.1.017.193.03.29h0a9.505,9.505,0,0,0,10.937,0ZM88.085,31.5c-.2-.169-.39-.345-.574-.528a9.5,9.5,0,1,1,13.435,0c-.182.184-.374.36-.572.528,0-.065,0-.129,0-.193h0a6.153,6.153,0,0,0-4.562-5.94,3.673,3.673,0,1,0-3.172,0A6.152,6.152,0,0,0,88.082,31.3c0,.063,0,.128,0,.193Zm8.293-11.6a3.043,3.043,0,1,0,.889,2.15,3.043,3.043,0,0,0-.889-2.15Z",
    transform: "translate(0 0)",
    fill: "#f6f6f6",
    stroke: "#61277f",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarUserActive);
export default __webpack_public_path__ + "static/media/sidebar-user-active.d25fb8f6963388dad4a10a10f305efdb.svg";
export { ForwardRef as ReactComponent };